export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "indexWorker_34f183a.worker.js");
}
